import { render, staticRenderFns } from "./bottomSection.vue?vue&type=template&id=5235ecd2&scoped=true&"
import script from "./bottomSection.vue?vue&type=script&lang=js&"
export * from "./bottomSection.vue?vue&type=script&lang=js&"
import style0 from "./bottomSection.vue?vue&type=style&index=0&id=5235ecd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5235ecd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5235ecd2')) {
      api.createRecord('5235ecd2', component.options)
    } else {
      api.reload('5235ecd2', component.options)
    }
    module.hot.accept("./bottomSection.vue?vue&type=template&id=5235ecd2&scoped=true&", function () {
      api.rerender('5235ecd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/newTemplateMgr/components/patrolTemplate/comComponents/bottomSection.vue"
export default component.exports